"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TrashIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TrashIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M18,9 L17.5031493,18.108929 C17.4452947,19.1695975 16.5683631,20 15.5061179,20 L8.49388209,20 C7.43163685,20 6.55470532,19.1695975 6.49685067,18.108929 L6,9 L18,9 Z M10,10.5 C9.44771525,10.5 9,10.9477153 9,11.5 L9,11.5 L9,16.5 C9,17.0522847 9.44771525,17.5 10,17.5 C10.5522847,17.5 11,17.0522847 11,16.5 L11,16.5 L11,11.5 C11,10.9477153 10.5522847,10.5 10,10.5 Z M14,10.5 C13.4477153,10.5 13,10.9477153 13,11.5 L13,11.5 L13,16.5 C13,17.0522847 13.4477153,17.5 14,17.5 C14.5522847,17.5 15,17.0522847 15,16.5 L15,16.5 L15,11.5 C15,10.9477153 14.5522847,10.5 14,10.5 Z M13,4 C13.5522847,4 14,4.44771525 14,5 L14,6 L18,6 C18.5522847,6 19,6.44771525 19,7 C19,7.55228475 18.5522847,8 18,8 L6,8 C5.44771525,8 5,7.55228475 5,7 C5,6.44771525 5.44771525,6 6,6 L10,6 L10,6 L10,5 C10,4.44771525 10.4477153,4 11,4 L13,4 Z" })
  );
}